import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import FetchingSelect from '@/components/FetchingSelect';
import { RunEventAchievementType, UpsertRunEventAchievementType } from '@/models/achievement.model';
import { getRunEventsLookup } from '@/services/run-event.service';
import { getRunEventDistancesLookup } from '@/services/run-event-distance.service';

const modelSchema = Schema.Model<UpsertRunEventAchievementType>({
  runEventDistanceId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertRunEventAchievementType = {
  runEventDistanceId: undefined,
};
export interface RunEventAchievementInitValue {
  runEventId?: number,
  runEventDistanceId?: number,
};

interface RunEventFormProps{
  formObject?: RunEventAchievementType;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
  initValue?: RunEventAchievementInitValue;
}

const RunEventForm: React.FC<RunEventFormProps> = ({ formObject, onFormChange, formRef, loading, initValue }) => {
  const [formValue, setFormValue] = useState<UpsertRunEventAchievementType>(emptyModel);
  const [runEventId, setRunEventId] = useState<number|undefined>(undefined);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
      setRunEventId(formObject.runEventId);
    } else {
      setFormValue({...emptyModel, runEventDistanceId: initValue?.runEventDistanceId});
      setRunEventId(initValue?.runEventId);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-first-country' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="runEventId">
              <Form.Label>Run Event</Form.Label>
              <FetchingSelect block
                fetchData={(text, page) => getRunEventsLookup(text, page)} 
                placeholder="Select a runEvent"
                value={runEventId}
                onChange={val => {setRunEventId(val); setFormValue(pre => ({...pre, runEventDistanceId: undefined}));}}
              />   
            </Form.Group>
          </Col>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="runEventDistanceId">
              <Form.Label>Run Event Distance</Form.Label>
              <Form.Control name="runEventDistanceId" accepter={FetchingSelect} block
                fetchData={(text, page) => getRunEventDistancesLookup(text, runEventId, page)} 
                placeholder="Select a distance"
                value={formValue.runEventDistanceId}
                onChange={val=> setFormValue(pre => ({...pre, runEventDistanceId: val}))}
                reFetchOnOpen={true}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default RunEventForm;